import React from 'react';
import { Link } from 'react-router-dom';
import { ActionResolution } from '../../../services/trips/actionRequests';
import './chatCards.css';

interface ActionResolutionViewProps {
  resolution: ActionResolution;
  note?: string;
  tripId?: string;
  backTo?: string;
}

const ActionResolutionView: React.FC<ActionResolutionViewProps> = ({
  resolution,
  note,
  tripId,
  backTo = '/ask-ai',
}) => (
  <div className={`v2-chat-card__resolution v2-chat-card__resolution--${resolution}`}>
    {resolution === 'confirmed' && (
      <>
        <p>{note || '✓ Confirmed'}</p>
        {tripId && (
          <Link
            to={`/trips/${tripId}`}
            state={{ owned: true, backTo }}
            className="v2-chat-card__trip-link"
          >
            Go to your trip
          </Link>
        )}
      </>
    )}
    {resolution === 'dismissed' && '✕ Dismissed'}
    {resolution === 'failed' && (note ? `⚠ ${note}` : '⚠ Failed — try again')}
  </div>
);

export default ActionResolutionView;
